import type { Phrases } from '../Phrases.d';

import React from 'react';
import { useController, useWatch } from 'react-hook-form';
import { useFormContext } from '../../../../components/react-hook-form/FormContext';
import { ToggleButton } from '../../../../components/toggleButton/ToggleButton';
import {
	COMMON_FIELD_NAME,
	SUBSTANCE,
} from '../constants';

const SUBSTANCE_OTHER_BUTTON_DESCRIPTION_ID = 'substanceOtherButtonDescriptionId';

export const SubstanceOtherButton = ({
	phrases,
}: {
	phrases: Phrases;
}): React.JSX.Element => {
	const label = phrases['notificationForm.common.substanceOtherButton.label'];
	const ariaDescriptionChecked = phrases['notificationForm.common.substanceOtherButton.ariaDescription.checked'];
	const ariaDescriptionUnChecked = phrases['notificationForm.common.substanceOtherButton.ariaDescription.unChecked'];

	const {
		control,
	} =	useFormContext();

	const {
		field: {
			onChange,
		},
		fieldState: {
			error: substanceError,
		},
	} = useController({
		control,
		name: COMMON_FIELD_NAME.SUBSTANCE,
	});

	const substance = useWatch({ control, name: COMMON_FIELD_NAME.SUBSTANCE}) as string;
	const pressed = substance === SUBSTANCE.OTHER;

	return (
		<>
			<ToggleButton
				aria-describedby={SUBSTANCE_OTHER_BUTTON_DESCRIPTION_ID}

				// IMPORTANT: Since the AutoComplete already uses that label, this would make
				// screenreaders read it another time. Which we don't want.
				// aria-labelledby={SUBSTANCE_LEGEND_ID}

				error={!!substanceError}
				label={label}
				pressed={pressed}
				onClick={() => {
					onChange(pressed ? null : SUBSTANCE.OTHER);
				}}
			/>
			<span
				className='hidden'
				id={SUBSTANCE_OTHER_BUTTON_DESCRIPTION_ID}
			>
				{
					pressed
						? ariaDescriptionChecked
						: ariaDescriptionUnChecked
				}
			</span>
		</>
	);
};
